
import queryString from "query-string";
import { $CombinedState } from "redux";
import services from "../../../../services";
import $ from 'jquery';
import ClassGrid2 from "../Grid2/ClassGrid2";
import { getItems2} from "../Grid2/services2";
import DropDownCellNVasilha from "../myDropDownCellNVasilha"
import ClassGrid from "./ClassGrid";


let data = [];
let data2 = [];
const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.Columns = [];
    item.IDAutoDetalhe = 0;
    data.unshift(item);
    return data;
};


export const deleteAll = () => {
    data = [];
    return data;
};
export const dataGet = async () => {
    return data;
};

export const getItems = async (requisicao) => {
    var ArrayDetalhesGrid = []
    
    if(window.location.search != ""){
            var queryParams = queryString.parse(window.location.search)
            var  token = queryParams.idAuto
            var  dataToken = {"idAuto": token}
            var Detalhes = await services.apiCall.requestApi(
                "/Fiscalizacao/GetAutoDetalhe",
                dataToken,
                "get"
            ); 
       
            for (let index = 0; index < Detalhes.autoGrid.length ; index++) {
                var etiqueta_ivdp = []
                var etiqueta_ae = []
                var etiquetasSegurancaAE = []
                var etiquetasSegurancaIVDP = []
                var SelosSeguranca = []
                var selos = []
                var selosGarantia_IVDP = []
                var selosGarantia_AE = []
                var selosGarantiaIVDP = []
                var selosGarantiaAE = []
                var capacidadeAE = Detalhes.autoGrid[index].capacidadeAE;
                var capacidadeCalculada = Detalhes.autoGrid[index].capacidadeCalculada;
                var capacidadeIVDP = Detalhes.autoGrid[index].capacidadeIVDP;
                var contaCorrenteDesc = Detalhes.autoGrid[index].contaCorrenteDesc;
                var falta = Detalhes.autoGrid[index].falta;
                var idCapacidadeAE = Detalhes.autoGrid[index].idCapacidadeAE;
                var idCapacidadeIVDP = Detalhes.autoGrid[index].idCapacidadeIVDP;
                var idContaCorrente = Detalhes.autoGrid[index].idContaCorrente;
                var idVasilha = Detalhes.autoGrid[index].idVasilha;
                var numeroGarrafasAE = Detalhes.autoGrid[index].numeroGarrafasAE;
                var numeroGarrafasIVDP = Detalhes.autoGrid[index].numeroGarrafasIVDP;
                var numeroRegisto = Detalhes.autoGrid[index].numeroRegisto;
                var numeroVasilha = Detalhes.autoGrid[index].numeroVasilha;
                var quantidadeAferida = Detalhes.autoGrid[index].quantidadeAferida;
                var registoDeposito = Detalhes.autoGrid[index].registoDeposito;
                var tipoMedicao = Detalhes.autoGrid[index].tipoMedicao;
                var tipoVasilha =  Detalhes.autoGrid[index].tipoVasilha;
                var linha = Detalhes.autoGrid[index].linha;
                var documentoEntrada = Detalhes.autoGrid[index].documentoEntrada;
                var documentoSaida = Detalhes.autoGrid[index].documentoSaida;
                var idRegistoProduto = Detalhes.autoGrid[index].idRegistoProduto;
                var idRotulo = Detalhes.autoGrid[index].idRotulo;
                var correlativa =  Detalhes.autoGrid[index].correlativa;
                var numeroLote = Detalhes.autoGrid[index].numeroLote;
                var numeroGarrafasDevolvidas = Detalhes.autoGrid[index].numeroGarrafasDevolvidas;
                var numeroLote = Detalhes.autoGrid[index].numeroLote;
                var quantidadeFinal = Detalhes.autoGrid[index].quantidadeFinal;
                var numeroGarrafasAmostra = Detalhes.autoGrid[index].numeroGarrafasAmostra;
                var motivoDispensa = Detalhes.autoGrid[index].motivoDispensa;
                var capacidadeCorrelativa = Detalhes.autoGrid[index].capacidadeCorrelativa;
                var RegistoProduto= {text: Detalhes.autoGrid[index].contaCorrenteDesc , value: Detalhes.autoGrid[index].idContaCorrente};
                var Correlativa= Detalhes.autoGrid[index].correlativa;
                var NLote= Detalhes.autoGrid[index].numeroLote ;
                var NGarrafas= String(Detalhes.autoGrid[index].numeroGarrafasAE);
                var ProductID= Detalhes.autoGrid[index].linha;
                var quantidadeAferida = Detalhes.autoGrid[index].quantidadeAferida;
                var quantidadeAferidaIE = Detalhes.autoGrid[index].quantidadeAferidaIE;
                var quantidadeAferidaIG = Detalhes.autoGrid[index].quantidadeAferidaIG;
                var quantidadeAferidaPA = Detalhes.autoGrid[index].quantidadeAferidaPA;
                var quantidadeAferidaVendas = Detalhes.autoGrid[index].quantidadeAferidaVendas;
                var quantidadeFinal = Detalhes.autoGrid[index].quantidadeFinal;
                var quantidadeTotalIE = Detalhes.autoGrid[index].quantidadeTotalIE;
                var quantidadeTotalIG = Detalhes.autoGrid[index].quantidadeTotalIG;
                var quantidadeTotalPA = Detalhes.autoGrid[index].quantidadeTotalPA;
                var tipoRotulo = Detalhes.autoGrid[index].tipoRotulo;
                var TotalQBD= Detalhes.autoGrid[index].quantidadeFinal;
                var tipoRotulo = Detalhes.autoGrid[index].tipoRotulo;
                var descricaoRotulo = Detalhes.autoGrid[index].descricaoRotulo;
                var quantidadeRotulo = Detalhes.autoGrid[index].quantidadeRotulo;
                var idTipoVasilha =  Detalhes.autoGrid[index].idTipoVasilha;
                var idContaCorrenteEngarrafado = Detalhes.autoGrid[index].idContaCorrente == -2 ? 'Outros' : Detalhes.autoGrid[index].idContaCorrente == -1 ? 'ProdutosSemConta' : Detalhes.autoGrid[index].idContaCorrente;
                var idProdutoSemContaEnga = Detalhes.autoGrid[index].produtosSemConta;
                var ano = Detalhes.autoGrid[index].anoEngarrafado;
                var idcor = Detalhes.autoGrid[index].idCorEngarrafado

                if(correlativa != null){
                    var valor = correlativa.split("-")[1]
                }else{
                    var valor = ""
                }
                etiquetasSegurancaAE = Detalhes.autoGrid[index].etiquetasSegurancaAE;
                etiquetasSegurancaIVDP = Detalhes.autoGrid[index].etiquetasSegurancaIVDP;
                selosGarantiaIVDP = Detalhes.autoGrid[index].selosGarantiaIVDP;
                selosGarantiaAE = Detalhes.autoGrid[index].selosGarantiaAE;
                etiquetasSegurancaIVDP = Detalhes.autoGrid[index].etiquetasSegurancaIVDP;
                selos = Detalhes.autoGrid[index].selosSeguranca;
                
                if(etiqueta_ae.length == 0){
                    etiquetasSegurancaAE.map((etiquetasSegurancaAE) => (
                        etiqueta_ae.push(etiquetasSegurancaAE.idEtiqueta)
                    
                    ));
                }
                if(etiqueta_ivdp.length == 0){
                    etiquetasSegurancaIVDP.map((etiquetasSegurancaIVDP) => (
                        etiqueta_ivdp.push(etiquetasSegurancaIVDP.idEtiqueta )
                    
                    ));
                }

                if(selos != undefined){
                    if(SelosSeguranca.length == 0){
                        selos.map((selos) => (
                            SelosSeguranca.push(selos.idSelo )
                        
                        ));
                    }
                }
                if(selosGarantia_IVDP.length == 0){
                    selosGarantiaIVDP.map((selosGarantiaIVDP) => (
                        selosGarantia_IVDP.push(selosGarantiaIVDP )
                    
                    ));
                }
                if(selosGarantia_AE.length == 0){
                    selosGarantiaAE.map((selosGarantiaAE) => (
                        selosGarantia_AE.push(selosGarantiaAE )
                    
                    ));
                }
                if($("#tipo_auto :selected").val() == "1"){
                   
                    data.push({ 
                        Capacidade_AE: {text: capacidadeAE , value: idCapacidadeAE},
                        Capacidade_IVDP: {text: capacidadeIVDP , value: idCapacidadeIVDP},
                        QuantidadeApurada : quantidadeAferida,
                        Columns: [],
                        IDAutoDetalhe: Detalhes.autoGrid[index].idAutoDetalhe,
                        Discontinued: false,
                        Falta: falta,
                        N_Garrafas_AE: String(numeroGarrafasAE),
                        N_Garrafas_IVDP: String(numeroGarrafasIVDP),
                        N_Vasilha:   {text: numeroVasilha, value: idVasilha, CapacidadeCalculada: capacidadeCalculada}, 
                        ProductID: linha ,
                        Produto_NC_GA_IG: {text: contaCorrenteDesc , value: idContaCorrente},
                        Quantidade_aferida: quantidadeAferida ,
                        Reg_Depos: registoDeposito == "Sim" ? registoDeposito = true : registoDeposito = false ,
                        Tipo_Vasilha: {text: tipoVasilha , value: idTipoVasilha},
                        Tipo_med: {text: tipoMedicao , value: ''}, 
                        inEdit: false,
                        Etiquetas_segurança_IDVP: etiqueta_ivdp,
                        Etiquetas_segurança_AE: etiqueta_ae,
                        idProdutosSemConta : idProdutoSemContaEnga,
                        Ano: ano,
                        idCor: idcor,
                        idContaCorrenteEng: idContaCorrenteEngarrafado,
                    }) 
                    //DropDownCellNVasilha.ChangeValueById(data)
                } else if($("#tipo_auto :selected").val() == "2"){
                    data.push({ 
                        RegistoProduto: {text: contaCorrenteDesc , value: idContaCorrente},
                        VolumeAferido: quantidadeAferida ,
                        SelosSeguranca: SelosSeguranca,
                        NGarrafasIVDP: String(numeroGarrafasIVDP),
                        Capacidade_IVDP: {text: capacidadeIVDP , value: idCapacidadeIVDP},
                        EtiquetasSegurancaIVDP: etiqueta_ivdp,
                        NGarrafasAE: String(numeroGarrafasAE),
                        Capacidade_AE: {text: capacidadeAE , value: idCapacidadeAE},
                        EtiquetasSegurancaAE: etiqueta_ae,
                        Columns: [],
                        IDAutoDetalhe: Detalhes.autoGrid[index].idAutoDetalhe,
                        Discontinued: false, 
                        ProductID: linha ,
                        inEdit: false,
                        
                    }) 
                } else if($("#tipo_auto :selected").val() == "3"){
                    data.push({ 
                        DocSaída: documentoSaida,
                        DocEntrada: documentoEntrada,
                        Registo : {text: numeroRegisto, value: idRegistoProduto},
                        Correlativa: {text: correlativa, value: valor, idRotulo: idRotulo},
                        NLote: numeroLote,
                        NGarrafasDevolvidas: numeroGarrafasDevolvidas,
                        Capacidade: parseInt(capacidadeCorrelativa),
                        QtdFinal : quantidadeFinal,
                        NGarrafasAmostra: numeroGarrafasAmostra,
                        MotivoDispensa: { text: motivoDispensa, value: motivoDispensa},
                        Columns: [],
                        IDAutoDetalhe: Detalhes.autoGrid[index].idAutoDetalhe,
                        Discontinued: false, 
                        ProductID: linha ,
                        inEdit: false,
                        Etiquetas_segurança_IDVP: etiqueta_ivdp,
                    }) 
                } else if($("#tipo_auto :selected").val() == "5"){
                    data.push({ 
                        RegistoProduto: {text: contaCorrenteDesc , value: idContaCorrente},
                        // Correlativa: {text: res.autoGrid[index].correlativa , value: res.autoGrid[index].idRotulo},
                        Correlativa: correlativa,
                        NLote: numeroLote ,
                        NGarrafas: String(numeroGarrafasAE),
                        ProductID: linha,
                        IDAutoDetalhe: Detalhes.autoGrid[index].idAutoDetalhe,
                        // IDAutoDetalhe: Detalhes.autoGrid[index].idAutoDetalhe,
                        // Capacidade: Detalhes.autoGrid[index].capacidadeAE,
                        Discontinued: false,
                        Columns: [],
                        TotalQBD: quantidadeFinal, 
                        inEdit: false
                    })
                    //// inicio FDO (grid 1) 
                  } else if($("#tipo_auto :selected").val() == "4"){
                    data.push({ 
                        Registo : {text: numeroRegisto, value: idRegistoProduto},
                        Correlativa: {text: correlativa, value: valor, idRotulo: idRotulo},
                        CapacidadeFDO: {text: capacidadeIVDP , value: idCapacidadeIVDP},
                        NLote: numeroLote ,
                        NGarrafasIVDP: String(numeroGarrafasIVDP),
                        EtiquetasSegurancaIVDP: etiqueta_ivdp,
                        NGarrafasAE: String(numeroGarrafasAE),
                        EtiquetasSegurancaAE: etiqueta_ae,
                        SelosGarantiaAE : selosGarantia_AE,
                        SelosGarantiaIVDP : selosGarantia_IVDP,
                        Discontinued: false,
                        IDAutoDetalhe: Detalhes.autoGrid[index].idAutoDetalhe,
                        ProductID: linha ,
                        Columns: [],
                        inEdit: false
                    })  
                    //// Fim FDO (grid 1) 
                    //// inicio apuramento rotulos/selos
                  }else if($("#tipo_auto :selected").val() == "9"){
                    data.push({ 
                        tipo_rotulos : {text: tipoRotulo},
                        Registo_rotulos : {text: numeroRegisto, value: idRegistoProduto},
                        Correlativa_rotulos: {text: correlativa, value: valor, idRotulo: idRotulo},
                        Descricao_rotulos: descricaoRotulo,
                        Quantidade_rotulos: quantidadeRotulo,
                        ProductID: linha,
                        IDAutoDetalhe: Detalhes.autoGrid[index].idAutoDetalhe,
                        Discontinued: false,
                        Columns: [],
                        inEdit: false
                    })
                       //// Fim apuramento rotulos/selos  
                        //// Inicio selagem (grid1)
                  }
            }
           if($("#tipo_auto :selected").val() == "6" || $("#tipo_auto :selected").val() == "15"){
           
            for (let i = 0; i < Detalhes.autoGridGranel.length ; i++) {
               
                var Sinetes =  Detalhes.autoGridGranel[i].sinetes
                var NumeroGarrafasRecolhaAmostra = Detalhes.autoGridGranel[i].numeroGarrafasRecolhaAmostra
                var IDCapacidadeRecolhaAmostra = Detalhes.autoGridGranel[i].idCapacidadeRecolhaAmostra
                var EtiquetasSegurancaRecolhaAmostras = Detalhes.autoGridGranel[i].etiquetasSegurancaRecolhaAmostrasVasilhas
                var tipoVasilha =  Detalhes.autoGridGranel[i].tipoVasilha;
                var idTipoVasilha =  Detalhes.autoGridGranel[i].idTipoVasilha;
                var idVasilha = Detalhes.autoGridGranel[i].idVasilha;
                var numeroVasilha = Detalhes.autoGridGranel[i].numeroVasilha;
                var quantidadeAferida = Detalhes.autoGridGranel[i].quantidadeAferida;
                var quantidadeFinal = Detalhes.autoGridGranel[i].quantidadeFinal;
                var falta = Detalhes.autoGridGranel[i].falta;
                var contaCorrenteDesc = Detalhes.autoGrid[i].contaCorrenteDesc;
                var idContaCorrente = Detalhes.autoGrid[i].idContaCorrente;
                var selos = []
                var capacidadeCalculada = Detalhes.autoGridGranel[i].capacidadeCalculada;
                var EtiquetasSegurancaSelagem =  Detalhes.autoGridGranel[i].etiquetasSegurancaSelagemVasilhas 
                var etiqueta_SegurancaSelagem = []
                var etiqueta_SegurancaRecolhaAmostra = []
                var linha = Detalhes.autoGridGranel[i].linha;
                var selosGarnel = Detalhes.autoGridGranel[i].selosSeguranca; 
                var etiquetasRecAmostra =  []
                var etiquetasSeguranca = []
                var CapacidadeRecolhaAmostra = Detalhes.autoGridGranel[i].capacidadeRecolhaAmostra
                if(etiquetasRecAmostra.length == 0){
                    EtiquetasSegurancaRecolhaAmostras.map((EtiquetasSegurancaRecolhaAmostras) => (
                        etiquetasRecAmostra.push(EtiquetasSegurancaRecolhaAmostras.idEtiqueta)
                    
                    ));
                }
                if(etiquetasSeguranca.length == 0){
                    EtiquetasSegurancaSelagem.map((EtiquetasSegurancaSelagem) => (
                        etiquetasSeguranca.push(EtiquetasSegurancaSelagem.idEtiqueta)
                    
                    ));
                }
                if(selos.length == 0){
                    selosGarnel.map((selosGarnel) => (
                        selos.push(selosGarnel.idSelo)
                    
                    ));
                }
                    data.push({ 
                        Tipo_Vasilha : {text: tipoVasilha , value: idTipoVasilha},
                        N_Vasilha_granel :  {text: numeroVasilha, value: idVasilha, CapacidadeCalculada: capacidadeCalculada},
                        Capacidade_aferida : quantidadeAferida,
                        Quantidade_apurada : quantidadeFinal,
                        Falta_granel : falta,
                        Produto_NC_GA_IG_granel: {text: contaCorrenteDesc , value: idContaCorrente},
                        SelosSeguranca_granel : selos,
                        Etiquetas_selagem_granel : etiquetasSeguranca ,
                        Sinetes_granel: Sinetes,
                        NGarrafasAmostra_granel : NumeroGarrafasRecolhaAmostra,
                        Capacidade_Amostra_granel : {text: CapacidadeRecolhaAmostra, value: IDCapacidadeRecolhaAmostra},
                        Etiquetas_RecolhaAmostra_granel : etiquetasRecAmostra,
                        ProductID: linha,
                        IDAutoDetalhe: Detalhes.autoGridGranel[i].idAutoDetalhe,
                        Discontinued: false,
                        Columns: [],
                        inEdit: false,
                        idProdutosSemConta : idProdutoSemContaEnga,
                        Ano: ano,
                        idCor: idcor,
                        idContaCorrenteEng: idContaCorrenteEngarrafado,
                    })
                    //// FIM selagem (grid1)
            }
           }
            return data;  
    }else if(requisicao){
        data.push({  
            Capacidade_Amostra_granel: "",
            Capacidade_aferida: "",
            Columns: [],
            Discontinued: false,
            Etiquetas_RecolhaAmostra_granel: [],
            Etiquetas_selagem_granel:[],
            Falta_granel: "",
            IDAutoDetalhe: 0,
            NGarrafasAmostra_granel: requisicao.amostrasNumeroEmbalagens,
            N_Vasilha_granel: null,
            ProductID:0,
            Produto_NC_GA_IG_granel: {text: requisicao.produto, value: requisicao.idContaCorrente},
            Quantidade_apurada: requisicao.amostrasVolumeTotal,
            SelosSeguranca_granel: requisicao.idSeloGarantia != "" ? requisicao.idSeloGarantia : [] ,
            Sinetes_granel: "",
            Tipo_Vasilha: {text: requisicao.tipoVasilha, value: requisicao.idTipoVasilha},
            inEdit: false,
        })
        ClassGrid.ClassGrid.updateData(data);
        return data;  
    }else{
        return data
    }
}

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const insertItem2 = dataArray => {
    // item.ProductID = generateId(data);
    // item.inEdit = false;
    // item.Columns = [];
    // item.IDAutoDetalhe = 0;
    // data.unshift(item);
    data = dataArray
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
